<template>
	<div class="test">
		<sBox title="Grade de vacinas">
			<div slot="tools">
				<div class="box-excel-export">
					<!-- <aBtn
					action='private-save-vacinas2'
					@click='$refs.modalExcel.open()'
					text='Importar Excel' icon='plus' size='sm' type='info'
					class="btn-export"
				/> -->

					<aBtn
						@click="handleConvertTableToXLS()"
						text="Exportar Excel"
						icon="minus"
						size="sm"
						type="info"
						class="btn-import"
					/>
				</div>
			</div>
			<div slot="body">
				<br />
				<sBox title="Filtrar Vacinas">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>CPF</span>
							<input
								v-mask="'###.###.###-##'"
								placeholder="999.999.999-99"
								v-model="filter.CPF"
								@input="fxFilter('CPF', $event.target.value)"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>Colaborador</span>
							<input
								v-model="filter.nome"
								placeholder="COLABORADOR"
								@input="fxFilter('nome', $event.target.value)"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>Navio</span>
							<input
								v-model="filter.navio"
								placeholder="NAVIO"
								@input="fxFilter('navio', $event.target.value)"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-3">
							<span>Status Vacina</span>
							<input
								v-model="filter.status_teste"
								placeholder="STATUS VACINA"
								@input="
									fxFilter(
										'status_teste',
										$event.target.value
									)
								"
								type="number"
								class="form-control"
							/>
						</div>
					</div>
				</sBox>

				<br />

				<div class="box-excel-export">
					<aBtn
						action="private-save-vacinas"
						@click="$refs.modalCriarVacina.open()"
						text="Vacinas"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<accordionGrid
					ref="tab"
					actionRead="private-read-vacinas"
					actionDelete="private-delete-vacinas"
					actionDeleteAll="private-custom-allvacinas"
					:labels="labels"
					:actions="['delete', 'deleteAll', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
					@subEdit="(data) => $refs.modalSubEdit.open(data)"
					@anexx="(data) => $refs.anexarImagemModal.open(data)"
				/>
			</div>
		</sBox>
		<!-- <anexar-imagem-modal ref='anexar'/> -->
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" :vacinasData="vacinasData" />
		<modalSubEdit ref="modalSubEdit" @update="$refs.tab.updateTable()" />
		<anexarImagemModal ref="anexarImagemModal" id="anexarImagemModal" />
		<modalCriarVacina ref="modalCriarVacina" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import accordionGrid from 'app/accordion-grid';
	import { accordion, panel } from 'app/accordion';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import WBS from 'js/http';
	import modal2 from './modal2.vue';
	import anexarImagemModal from './anexarImagemModal.vue';
	import modalSubEdit from './modalSubEdit.vue';
	import modalCriarVacina from './modalCriarVacina.vue';

	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroVacinas',
		components: {
			sTable,
			sBox,
			modal,
			aBtn,
			modal2,
			anexarImagemModal,
			WBS,
			accordion,
			panel,
			accordionGrid,
			modalSubEdit,
			modalCriarVacina,
		},
		data() {
			return {
				vacinas: [],
				labels: [
					{ data: 'CPF', label: 'CPF', main: true },
					{ data: 'nome', label: 'Colaborador', main: true },
					{ data: 'empresa', label: 'EMPRESA', main: true },
					{ data: 'navio', label: 'NAVIO', main: true },
					{
						data: 'status_teste',
						label: 'STATUS VACINA',
						main: true,
					},
					{
						data: 'vacinas',
						multi: true,
						subLabels: [
							'data',
							'marca da vacina',
							'tipo vacina',
							'anexo',
						],
					},
				],
				vacinasData: '',

				filter: {
					nome: '',
					CPF: '',
					navio: '',
					status_teste: '',
				},
				functions: [
					{
						cod: 'CPF',
						fx: (val) => {
							return val
								.toString()
								.replace(
									/(\d{3})(\d{3})(\d{3})(\d{2})/g,
									'\$1.\$2.\$3\-\$4'
								);
						},
					},
				],
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.CPF != '')
					f.push(
						`v.CPF like '%${this.filter.CPF.replace(
							/[^\w\s]/gi,
							''
						)}%'`
					);

				if (this.filter.nome != '')
					f.push(`v.nome like '%${this.filter.nome}%'`);

				if (this.filter.status_teste != '')
					f.push(
						`v.status_teste like '${this.filter.status_teste}%'`
					);

				if (this.filter.navio != '')
					f.push(`v.navio like '%${this.filter.navio}%'`);

				f = f.join(' and ');

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			loadvacinas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999999',
					},
				};

				WBS.send('private-read-vacinas', testParms, async (resp) => {
					console.log(resp);

					this.vacinasData = JSON.parse(
						JSON.stringify(resp.data.table)
					);

					console.log(this.vacinasData);

					var rows = JSON.parse(JSON.stringify(resp.data.table));

					this.vacinas = await this.handleNormalizevacinasKeys(rows);
					return rows;
				});
			},

			handleNormalizevacinasKeys(vacinasData) {
				let vacinas = vacinasData;

				let normalizedvacinas = [];

				vacinas.map((exam) => {
					const handleSetDateYearAndTime = (e) =>
						this.handleSetDateYearAndTime(e);
					const handleChangeKey = (e) => this.handleChangeKey(e);

					Object.keys(exam).map(function (oldExamKey, label) {
						const newExamKey =
							handleChangeKey(oldExamKey) || oldExamKey;

						let newexamValue = exam[oldExamKey];

						if (newExamKey == 'DATA') {
							newexamValue = handleSetDateYearAndTime(
								exam[oldExamKey]
							);
						}

						exam[newExamKey] = newexamValue;

						if (newExamKey != oldExamKey) delete exam[oldExamKey];
					});

					const orderedExam = Object.keys(exam)
						.sort()
						.reduce((obj, key) => {
							obj[key] = exam[key];
							return obj;
						}, {});
					/*
						1 - formatar ele na ordem especifica
						2 - criar o formattedExam, com a ordem certa
						3 - merge nos dois
						*/

					// obj <- propriedades de exam
					const examOrder = {
						EMPRESA: 0,
						'': '',
						NOME: '',
						CARGO: '',
						SEÇÃO: '',
						FROTA: '',
						IDADE: '',
						TIPO: '',
						DATA: '',
						LABORATÓRIO: '',
						PARCEIRO: '',
						TEMPO_DE_ANÁLISE: '',
						MUNICÍPIO: '',
						ESTADO: '',
						'RG/PASS': '',
						CPF: '',
					};

					// Object.keys(examOrder).map(function(key, value) {
					Object.keys(examOrder).map(function (key, value) {
						examOrder[key] = orderedExam[key];
					});

					normalizedvacinas.push(examOrder);
				});

				return normalizedvacinas;
			},

			handleSetDateYearAndTime(date) {
				var data = new Date(date),
					dia = data.getDate().toString().padStart(2, '0'),
					mes = (data.getMonth() + 1).toString().padStart(2, '0'), //+1 pois no getMonth Janeiro começa com zero.
					ano = data.getFullYear(),
					horas = `0${data.getHours()}`.slice(-2),
					minutos = `0${data.getMinutes()}`.slice(-2);

				return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
			},

			handleChangeKey(key) {
				switch (key) {
					case 'cargo':
						return 'CARGO';

					case 'CPF':
						return 'CPF';

					case 'empresa':
						return 'EMPRESA';

					case 'estado':
						return 'ESTADO';

					case 'frota':
						return 'FROTA';

					case 'idade':
						return 'IDADE';

					case 'parceiro':
						return 'PARCEIRO';

					case 'nome':
						return 'NOME';

					case 'navio':
						return 'SEÇÃO';

					case 'laboratorio':
						return 'LABORATÓRIO';

					case 'municipio':
						return 'MUNICÍPIO';

					case 'RG':
						return 'RG/PASS';

					case 'data':
						return 'DATA';

					case 'tipo':
						return 'TIPO';

					default:
						return key;
				}
			},

			handleConvertDate(dateStr) {
				let date = new Date(dateStr);
				let options = {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				};
				date.toLocaleDateString('pt-BR', options);
			},

			handleConvertTableToXLS() {
				// const mainTable = document.querySelector('.table')

				const data = this.vacinas;

				// const jsonExcelData = XLSX.utils.book_append_sheet(this.vacinas)
				const filename = 'Dados dos Vacinas.xlsx';
				// XLSX.writeFile(jsonExcelData, (nameOfFile))

				var ws = XLSX.utils.json_to_sheet(data);
				var wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, 'People');
				XLSX.writeFile(wb, filename);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Vacinas', '']);

			this.loadvacinas();
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px !important;
	}

	.btn-export {
		filter: saturate(1.5);
	}

	.table,
	.table-striped,
	.table-hover {
		max-width: 100% !important;
		overflow-x: scroll !important;
		overflow-y: clip !important;
	}

	[data-v-4c24c5d2] [data-v-4481e0c6] {
		overflow-x: scroll !important;
		overflow-y: clip !important;
	}

	.cnt-pager[data-v-30c8dc48] {
		/*overflow-y: clip;*/
		overflow: initial !important;
	}

	[data-v-4fc2e1b0] {
		max-width: 100%;
		width: 100% !important;
		overflow-x: scroll;
		overflow-y: clip;
	}
	/*


.btn-import: hover{
	background-color: #1e5bd3
}


.btn-export: hover{
	background-color: #81a9ff;
}
*/
</style>

<!--
[
	{
		colaborador: "A",
		vacinas: [
			{
				tipo: "1",
				laboratório: "COVAXIN",
				data: "2022-05-01 08:15:00",
			},
			{
				tipo: "2",
				laboratório: "COVAXIN",
				data: "2022-07-01 08:15:00",
			},
			{
				tipo: "3",
				laboratório: "COVAXIN",
				data: "2022-09-01 08:15:00",
			},
		],
	},


	{
		colaborador: "B",
		vacinas: [
			{
				tipo: "1",
				laboratório: "ABBOTT",
				data: "2022-05-01 08:15:00",
			},
			{
				tipo: "2",
				laboratório: "ABBOTT",
				data: "2022-07-01 08:15:00",
			},
			{
				tipo: "3",
				laboratório: "ABBOTT",
				data: "2022-09-01 08:15:00",
			},
		],
	},
]

 -->



// WEBPACK FOOTER //
// src/components/cadastros/vacinas/index.vue